import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionElement } from "models";

type AddInterventionElementResponse = {
  intervention_element_id: number;
};

export const useAddInterventionSubitemsMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: InterventionElement) => (await ApiInstance.post("/interventions/element/add", payload)).data,
    onSuccess: (payload, { intervention_element_id }: AddInterventionElementResponse) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.id === payload.intervention_id);
      if (interventionIdx < 0 || appointment.interventions[interventionIdx].elements?.some(el => el.id === intervention_element_id)) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, {
          ...appointment.interventions[interventionIdx],
          elements: [...(appointment.interventions[interventionIdx].elements ?? []), { ...payload, id: intervention_element_id }]
        })
      });
    }
  });
